import { Store } from 'kioskApp/models/Index';
import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';

export function UseLoaderInterceptor(instance: AxiosInstance) {
    instance.interceptors.request.use(showLoaderOnRequest);
    instance.interceptors.response.use(hideLoaderOnResponse, hideLoaderOnError);

    return instance;
}

function showLoaderOnRequest(request: AxiosRequestConfig) {
    if (!(request as any).disableLoader) {
        Store.loader.show();
    }

    return request;
}

function hideLoaderOnResponse(response: AxiosResponse<any>) {
    if (!(response.config as any).disableLoader) {
        Store.loader.hide();
    }

    return response;
}

function hideLoaderOnError(error: any) {
    if (!error || !error.config || !error.config.disableLoader) {
        Store.loader.hide();
    }

    return Promise.reject(error);
}
